import FDTagFilterDropdown from "./tag/FDTagFilterDropdown";
import ResourceSelector from "./components/ResourceSelector";
import "styles/components/filterDropdown/fd_filter_dropdown.css";

const FDFilterDropdown = (props: any) => {
  const { Name = "", Field = "", tagView = null } = props;

  if (["tag", "flyout_tag"]?.includes(Field)) {
    return <FDTagFilterDropdown {...props} tagView={tagView} />;
  }

  if (Name?.includes("Resources")) {
    return (
      <ResourceSelector Name={"Resource"} Field={"resourceName"} anchorPosition="leftCenter" />
    );
  }

  return;
};

export default FDFilterDropdown;
